namespace Cfnc {

    interface IcategoryCheckMark extends ng.IDirective {

    }

    interface IcategoryCheckMarkScope extends ng.IScope {
        filterGroup: IAvaliableFiltersGroup;
        ngModel: IAvaliableFiltersGroup[];
        selected: boolean;
        vm: any;
    }

    class CategoryCheckMark implements IcategoryCheckMark {
        static directiveId: string = "categoryCheckMark";
        templateUrl = "/app/directives/campusSearchFilter/categoryCheckMark.html";
        replace: boolean = true;
        restrict: string = "E";
        scope: any =
        {
            ngModel: "=",
            filterGroup: "="
        };

        constructor(private $window: ng.IWindowService) {
        }

        link = (scope: IcategoryCheckMarkScope, element, attrs) => {
            scope.vm = {
                selected: true,
                filterGroup: scope.filterGroup,
            }

            scope.selected = false;

            scope.$watch("ngModel",(newValue: Array<any>) => {
               
                var catIndex = _.findIndex(newValue,(x: any) => {
                    return x.category === scope.vm.filterGroup.category;
                });

                if (catIndex > -1) {
                    scope.selected = true;
                } else {
                    scope.selected = false;
                }

            }, true);
        };
    }

    angular.module("app").directive(CategoryCheckMark.directiveId, ["$window", $window =>
        new CategoryCheckMark($window)
    ]);
}